import './App.scss';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import Home from './components/home/home';
import { Route, Routes } from 'react-router-dom';
import Room from './components/room/room';

firebase.initializeApp({
  apiKey: "AIzaSyAnzYwQZoS92SwESEjZyjMclAn8mq_mMZ4",
  authDomain: "tactime-5f55b.firebaseapp.com",
  projectId: "tactime-5f55b",
  storageBucket: "tactime-5f55b.appspot.com",
  messagingSenderId: "312243494453",
  appId: "1:312243494453:web:0be469bcd3bfdaa1479b7c",
  measurementId: "G-XGCTXHET5H"
})

const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {




  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/rooms/:roomId' element={<Room />} />
      </Routes>
    </div>
  );
}

export default App;
